import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import c, {
  ResetCaseState,
  UpdateSelectedPlan,
} from '@apps/shared/src/caseSelect/types/myCaseAction';
import { getAxiosRequestConfig } from '@apps/shared/src/utilities';

export interface CaseFilter {
  queryParam: string;
  type: string;
  createdDate: string;
  status: string;
  planID: string;
}

export const getCasesForClient = createAsyncThunk(
  'case/getCases',
  async (payload: CaseFilter, thunkAPI) => {
    const { type, createdDate, status, queryParam, planID } = payload;
    const token = localStorage.getItem('csrfToken') ?? '';
    if (token === '') return thunkAPI.rejectWithValue('');
    try {
      const res = await axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL || ''
        }/api/getClientCases?q=${queryParam}&type=${type}&createdDate=${createdDate}&status=${status}&masterplanID=${planID}`,
        getAxiosRequestConfig()
      );
      return { data: res.data.records };
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
export const getMyCases = createAsyncThunk(
  'case/getCases',
  async (payload: CaseFilter, thunkAPI) => {
    const { type, createdDate, status, queryParam } = payload;
    const token = localStorage.getItem('csrfToken') ?? '';
    if (token === '') return thunkAPI.rejectWithValue('');
    try {
      const res = await axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL || ''
        }/api/getCases?q=${queryParam}&type=${type}&createdDate=${createdDate}&status=${status}`,
        getAxiosRequestConfig()
      );
      return { data: res.data.records };
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const getClientCaseById = async (id: string) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL || ''}/api/clientCase/${id}`,
      getAxiosRequestConfig()
    );
    return res.data.records;
  } catch (e) {
    return e;
  }
};

export const getCaseById = async (id: string) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL || ''}/api/case/${id}`,
      getAxiosRequestConfig()
    );
    return res.data.records;
  } catch (e) {
    return e;
  }
};

export const getCaseStatus = async (caseType: string, status: string, statusDetail: string) => {
  try {
    const res = await axios.get(
      `${
        process.env.REACT_APP_API_BASE_URL || ''
      }/api/sfCaseStatus?casetype=${caseType}&status=${status}&statusdetail=${statusDetail}`,
      getAxiosRequestConfig()
    );
    return res.data;
  } catch (e) {
    return e;
  }
};

export const resetMyCasesState = (): ResetCaseState => {
  return {
    type: c.RESET_CASES,
  };
};

export const updateSelectedPlan = (planID: string): UpdateSelectedPlan => {
  return {
    type: c.UPDATE_SELECTED_PLAN,
    id: planID,
  };
};
